import { createClient } from '@supabase/supabase-js';

export const supabaseUrl = 
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SUPABASE_URL) ||
  (typeof process !== 'undefined' && (process.env.VITE_SUPABASE_URL || process.env.SUPABASE_URL)) ||
  'https://ztnsovldwkbddnuvpxfy.supabase.co';

// IMPORTANTE: precisa ser a chave "anon" legada (formato JWT), não a nova
// "sb_publishable_...". As Edge Functions fiscais (fiscal-cte, fiscal-nfse,
// fiscal-empresa, fiscal-auxiliar) têm verify_jwt=true e o gateway do Supabase
// rejeita com 401 qualquer Authorization que não seja um JWT válido.
export const supabaseAnonKey =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SUPABASE_ANON_KEY) ||
  (typeof process !== 'undefined' && process.env.VITE_SUPABASE_ANON_KEY) ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp0bnNvdmxkd2tiZGRudXZweGZ5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODc0NjcxODAsImV4cCI6MjEwMzA0MzE4MH0.VdbEONCfEGaQ1EYKkh4Z41tHoxdtfh0gNraaOknCwUA';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

